import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FuseSharedModule } from '@fuse/shared.module';
import { AgendaPopupComponent } from './components/agenda-popup/agenda-popup.component';
import { AuthorComponent } from './components/author/author.component';
import { CompanyBreadcrumComponent } from './components/company-breadcrum/company-breadcrum.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { DiagnosisCodeComponent } from './components/diagnosis-code/diagnosis-code.component';
import { DiagnosisSearchComponent } from './components/diagnosis-search/diagnosis-search.component';
import { FilterPipe } from './components/diagnosis-search/filter.pipe';
import { ReactiveFormsModule } from '@angular/forms';
import { SendSmsComponent } from './components/send-sms/send-sms.component';
import { CommonModule, DecimalPipe } from '@angular/common';
import { AngularMaterialModule } from '../../angular-material.module';
import { DecimalPointPipe } from './pipes/decimal-point.pipe';
import { HtmlFormatterPipe } from './pipes/html-formatter.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { TelephoneListPipe } from './pipes/telephone-list.pipe';
import { PhoneDirective } from './directives/phone.directive';
import { DragAndDropDirective } from './directives/drag-and-drop.directive';
import { ApiService } from './services/api.service';
import { FileService } from './services/file.service';
import { CalanderModule } from '../Calander/calander.module';
import { CommonDropdownService } from './services/common.dropdown.service';
import { SmsService } from './services/sms.service';
import { SharedService } from './services/shared-service';
import { SchedulerCalendarComponent } from './components/scheduler-calendar/scheduler-calendar.component';
// import { FullCalendarModule } from '@fullcalendar/angular';
import { ListFilterPipe } from './pipes/list-filter.pipe';
import { SpanishNumberPipe } from './pipes/spanish-number.pipe';
import { OnlyNumbersDirective } from './directives/only-numbers.directive';
import { TemplateSelectorComponent } from './components/leave/template-selector/template-selector.component';
import { DatePeriodSelectorComponent } from './components/date-period-selector/date-period-selector.component';
import { LanguageService } from './services/language-service';
import { SpanishNumberDirective } from './directives/spanish-number.directive';
import { PromptDialogComponent } from './components/prompt-dialog/prompt-dialog.component';
import { OkDialogComponent } from './components/ok-dialog/ok-dialog.component';
import { ModernAuthorComponent } from './components/modern-author/modern-author.component';
import { TemporaryComponent } from './pages/temporary/temporary.component';
import { GlobleAuthorComponent } from './components/globle-author/globle-author.component';
import { DownloadCalendarDialogComponent } from './components/scheduler-calendar/download-calendar-dialog/download-calendar-dialog.component';
import { TreeViewComponentNew } from '../fuse/components/tree-view-new/tree-view.component';

@NgModule({
    declarations: [
        AgendaPopupComponent,
        AuthorComponent,
        CompanyBreadcrumComponent,
        ConfirmationDialogComponent,
        DiagnosisCodeComponent,
        FilterPipe,
        SendSmsComponent,
        DiagnosisSearchComponent,
        DecimalPointPipe,
        HtmlFormatterPipe,
        SafeHtmlPipe,
        TelephoneListPipe,
        PhoneDirective,
        DragAndDropDirective,
        SchedulerCalendarComponent,
        ListFilterPipe,
        SpanishNumberPipe,
        OnlyNumbersDirective,
        TemplateSelectorComponent,
        DatePeriodSelectorComponent,
        SpanishNumberDirective,
        PromptDialogComponent,
        OkDialogComponent,
        ModernAuthorComponent,
        TemporaryComponent,
        GlobleAuthorComponent,
        TreeViewComponentNew,
        DownloadCalendarDialogComponent
    ],
    imports: [
        RouterModule,
        FuseSharedModule,
        CommonModule,
        ReactiveFormsModule,
        AngularMaterialModule,
        CalanderModule,
        // FullCalendarModule
    ],
    exports: [
        CompanyBreadcrumComponent,
        AuthorComponent,
        DecimalPointPipe,
        HtmlFormatterPipe,
        SafeHtmlPipe,
        TelephoneListPipe,
        SchedulerCalendarComponent,
        ListFilterPipe,
        SpanishNumberPipe,
        OnlyNumbersDirective,
        TemplateSelectorComponent,
        DatePeriodSelectorComponent,
        SpanishNumberDirective,
        ModernAuthorComponent,
        GlobleAuthorComponent,
        TreeViewComponentNew
    ],
    providers: [
        ApiService,
        FileService,
        CommonDropdownService,
        SmsService,
        SharedService,
        DecimalPipe,
        OnlyNumbersDirective,
        LanguageService,
        SpanishNumberDirective,
        SpanishNumberPipe,
    ]
})
export class SharedModule {
}
